module.exports = __webpack_public_path__ + "assets/img/advantages-4.77885179.svg";